import {
  RowDataReducerState,
  RowDataReducerActionPayload,
  RowDataValueType,
  RowDataObject,
  DeletedObjects,
  DeletedObjectsList,
} from "../../../types";

export const setDeletedObjectsAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { propertyKey, newFieldValue, selectedTabSectionKey } = payload;
  if (!propertyKey || newFieldValue === undefined) {
    return state;
  }

  if (selectedTabSectionKey) {
    return setNestedDeletedObjects(
      propertyKey,
      newFieldValue,
      selectedTabSectionKey,
      state,
    );
  }

  return setDeletedObjects(propertyKey, newFieldValue, state);
};

const setNestedDeletedObjects = (
  propertyKey: string,
  newFieldValue: RowDataValueType,
  selectedTabSectionKey: string,
  state: RowDataReducerState,
): RowDataReducerState => {
  const existingDeletedObjects =
    (state.deletedObjectsList[selectedTabSectionKey] as DeletedObjects)?.[
      propertyKey
    ] || [];
  const updatedDeletedObjects = [
    ...existingDeletedObjects,
    newFieldValue as RowDataObject,
  ];

  const updatedDeletedObjectsList = {
    ...state.deletedObjectsList,
    [selectedTabSectionKey]: {
      [propertyKey]: updatedDeletedObjects,
    },
  } as DeletedObjectsList;

  return {
    ...state,
    deletedObjectsList: updatedDeletedObjectsList,
  };
};

const setDeletedObjects = (
  propertyKey: string,
  newFieldValue: RowDataValueType,
  state: RowDataReducerState,
): RowDataReducerState => {
  const existingDeletedObjects =
    (state.deletedObjectsList[propertyKey] as RowDataObject[]) || [];
  const updatedDeletedObjects = [
    ...existingDeletedObjects,
    newFieldValue as RowDataObject,
  ];

  const updatedDeletedObjectsList = {
    ...state.deletedObjectsList,
    [propertyKey]: updatedDeletedObjects,
  } as DeletedObjectsList;

  return {
    ...state,
    deletedObjectsList: updatedDeletedObjectsList,
  };
};
